import React from "react";

function Submit({state, label}) {
    return (
        <button
            className="button"
            type="submit"
            disabled={state.submitting}
        >
            { label }
        </button>
    );
}

export default Submit;
